// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/workers/" + {"112":"jpegloss.worker","201":"resampling.worker","326":"rle.worker","391":"labeling.worker","557":"jpeg2000.worker","968":"jpegbaseline.worker"}[chunkId] + ".min.js";
};